'use client';
import React from 'react';
import PledgeFormsScreen from './screen';
import { CaptchaProvider } from '@/lib/CaptchaService/Provider';

const WrappedPledgeForm = (props: any) => {
	return (
		<>
			{/* <CaptchaProvider> */}
				<PledgeFormsScreen {...props} />
			{/* </CaptchaProvider> */}
		</>
	);
};

export default WrappedPledgeForm;
